import * as React from 'react';

import { MANAGE_API_TOKENS_CONTAINER } from 'src/ui/constants/testIds';
import { UserApiTokens } from 'src/ui/containers/api-tokens/UserApiTokens';
import { VoiceboxApps } from 'src/ui/containers/api-tokens/VoiceboxApps';
import { useProfile } from 'src/ui/hooks/connection';
import { isPublicApiV2Enabled } from 'src/ui/utils/features';

export const ManageApiTokens: React.VFC = () => {
  const { data: profileData } = useProfile();
  const hasVoiceboxApiAccess = Boolean(
    profileData?.profile?.is_voicebox_api_access_enabled
  );

  return (
    <div
      className="manage-api-tokens-container"
      data-testid={MANAGE_API_TOKENS_CONTAINER}
    >
      {isPublicApiV2Enabled() ? <UserApiTokens /> : null}
      {hasVoiceboxApiAccess ? <VoiceboxApps /> : null}
    </div>
  );
};
